// ##############################
// // // SweetAlert view styles
// #############################

import buttonStyle from "../../material-dashboard-pro-react/components/buttonStyle";

const sweetAlertStyle = {
  cardTitle: {
    marginTop: "0",
    marginBottom: "3px",
    color: "#3C4858",
    fontSize: "18px",
    float:"left"
  },

  headerTitle:{
    fontFamily: 'Roboto',
    fontWeight: '700',
    fontStyle: 'normal',
    fontSize: '12px',
    lineHeight: '14.06px',
    textAlign: 'center',
    marginTop: '12px',
  },

  headerSubtitle:{
    fontFamily: 'Roboto',
    fontWeight: '300',
    fontStyle: 'normal',
    fontSize: '18px',
    lineHeight: '21.09px',
    textAlign: 'center',
    paddingTop: '25px',
  },

  alertMsg:{
    fontFamily: 'Roboto',
    fontWeight: '300',
    fontStyle: 'normal',
    fontSize: '20px',
    lineHeight: '21.09px',
    textAlign: 'center',
  },

  projectName: {
    textAlign: 'center',
    fontSize: '24px',
    fontFamily: 'Roboto',
    fontWeight: '300',
    fontStyle: 'normal',
    lineHeight: '28.13px',
  },

  projectMsgConfirm: {
    fontFamily: 'Roboto',
    fontWeight: '300',
    fontStyle: 'normal',
    fontSize: '18px',
    lineHeight: '21.09px',
    textAlign: "center",
    paddingTop: '30px',
  },

  center: {
    textAlign: "center"
  },

  right: {
    textAlign: "right"
  },

  left: {
    textAlign: "left"
  },

  labelHorizontal: {
    // color: "rgba(" + hexToRgb(blackColor) + ", 0.26)",
    cursor: "pointer",
    display: "inline-flex",
    fontSize: "14px",
    lineHeight: "1.428571429",
    fontWeight: "400",
    paddingTop: "39px",
    marginRight: "0",
    "@media (min-width: 992px)": {
      float: "right"
    }
  },
  ...buttonStyle
};

export default sweetAlertStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx